import './App.css';
import {
  Button,
  Card,
  Divider,
  Image,
  Flex,
  Typography,
  Skeleton,
  Slider,
  Space,
  Switch,
} from 'antd';
import useSWR from 'swr';
import 'react-quill/dist/quill.snow.css';
import dayjs from 'dayjs';
import cookie from 'react-cookies';
import { LeftCircleOutlined, LinkOutlined } from '@ant-design/icons';

import { useNavigate, useParams } from 'react-router-dom';

import parse from 'html-react-parser';
import { HTMLReactParserOptions, Element } from 'html-react-parser';
import { useEffect, useState } from 'react';
import Loading from './Loading';

const { Title } = Typography;
const options: HTMLReactParserOptions = {
  replace(domNode) {
    if (domNode instanceof Element && domNode.attribs) {
      if (domNode.name === 'img') {
        if (domNode.attribs.class === 'ql-emotion') {
          return domNode;
        }
        return (
          <Image
            style={{ maxHeight: '500px' }}
            src={domNode.attribs.src}
            loading='lazy'
          />
        );
      }
    }
  },
};
const fetcher = async (url: string) => {
  const token = cookie.load('token');
  const res = await fetch(url, {
    headers: new Headers({
      'Access-Control-Allow-Origin': '*',
      Authorization: `Bearer ${token}`,
    }),
  });
  const json = await res.json();
  if (!json.success) {
    const error = new Error((await json).message);
    throw error;
  }
  return json;
};

const MarshmallowPublicPreview = () => {
  const { id } = useParams();
  const { data, error, isLoading } = useSWR(
    `https://api.lynne.com.cn/marshmallow/get?id=${id}`,
    fetcher
  );

  const [fontSize, setFontSize] = useState(20);
  const [lineHeight, setLineHeight] = useState(250);
  const changeFontSize = (size: number) => {
    setFontSize(size);
    localStorage.setItem('fontSize', `${size}`);
  };
  const changeLineHeight = (height: number) => {
    setLineHeight(height);
    localStorage.setItem('lineHeight', `${lineHeight}`);
  };
  const n = useNavigate();
  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    const fontSize = localStorage.getItem('fontSize');
    if (fontSize) {
      setFontSize(parseInt(fontSize));
    } else {
      setFontSize(20);
    }
    const lineHeight = localStorage.getItem('lineHeight');
    if (lineHeight) {
      setLineHeight(parseInt(lineHeight));
    } else {
      setLineHeight(250);
    }
  }, []);
  if (error) return <div>error...</div>;
  if (isLoading || data === undefined) return <Loading />;
  const files = data.data.files === '' ? [] : data.data.files.split('|');
  // 渲染数据
  return (
    <>
      <Flex align='center' gap={10}>
        <Button
          type='primary'
          shape='circle'
          icon={<LeftCircleOutlined />}
          onClick={() => n('/marshmallow')}
        />
        <Title level={3} style={{ margin: '15px 0', flex: 1 }}>
          棉花糖投稿
        </Title>
      </Flex>
      <Divider />
      <Card style={{ fontSize: `${fontSize}px` }}>
        <Flex align='center' gap={10}>
          <Title
            level={3}
            style={{ margin: '15px 0', flex: 1 }}
            className='font'>
            {data.data.title}
          </Title>
        </Flex>
        <div style={{ color: 'gray', fontSize: '16px' }}>
          {dayjs(data.data.time).format('投稿时间YYYY年MM月DD日 HH:mm:ss')}
        </div>
        <Flex gap={10} align='center' style={{ marginBottom: 10 }}>
          <div
            style={{
              fontSize: '16px',
            }}>
            字体大小
          </div>
          <Slider
            onChange={changeFontSize}
            style={{ flex: 1, maxWidth: '300px' }}
            defaultValue={fontSize}
            min={16}
            max={60}
          />
        </Flex>
        <Flex gap={10} align='center' style={{ marginBottom: 10 }}>
          <div
            style={{
              fontSize: '16px',
            }}>
            每行高度
          </div>
          <Slider
            onChange={changeLineHeight}
            style={{ flex: 1, maxWidth: '300px' }}
            defaultValue={lineHeight}
            min={100}
            max={300}
          />
        </Flex>
        <Divider />
        <div
          className='marshmallow font'
          style={{ lineHeight: `${lineHeight}%` }}>
          {parse(data.data.content, options)}
        </div>
      </Card>
      {files.length !== 0 && (
        <>
          <Divider />
          <Title level={4} style={{ margin: '15px 0', flex: 1 }}>
            附件列表
          </Title>
          <Space direction='vertical' size={'middle'} style={{ width: '100%' }}>
            {files.map((file: string, index: number) => {
              return (
                <Flex align='center' key={file} gap={5}>
                  <Card
                    style={{ flex: 1 }}
                    hoverable
                    onClick={(e: any) => {
                      window.open(`https://dd.lynne.com.cn/file/${file}`);
                    }}>
                    <Flex align='center' gap={5}>
                      <LinkOutlined />
                      <div style={{ flex: 1 }}>{decodeURI(file)}</div>
                    </Flex>
                  </Card>
                </Flex>
              );
            })}
          </Space>
        </>
      )}
    </>
  );
};

export default MarshmallowPublicPreview;
